import {fsiTheme} from "../theme";
import {Page, Header, Separator} from "../App";
import {useEffect, useState} from "react";
import {Button} from "../components/Button";
import {useNavigate} from "react-router";

export function HomePage(){


    return (
        <Page>
            <About/>
        </Page>
    );
}

function About(){
    const nav = useNavigate()
    const [floatImg, setFloatImg] = useState(window.innerWidth > 1050)
    const breakHandler = () =>{
        if(window.innerWidth > 1050){
            setFloatImg(true)
        } else{
            setFloatImg(false)
        }
    }
    useEffect(() => {
        window.addEventListener('resize', breakHandler)
        return () => window.removeEventListener('resize', breakHandler)
    }, []);
    return(
        <>


            <div>
                <Companies floatImg={floatImg}/>
                <Separator/>
                <FSICube floatImg={floatImg}/>
                <WhyUs/>
                <Buttons/>

            </div>
        </>
)
}

function Companies({
    floatImg
}){
    return (
        <div style={{textAlign: 'center'}}>
            <h1>
                Companies That Trust Our Software Experts
            </h1>
            <div style={{marginLeft: floatImg ? 75 : 0}}>
                <img src="/images/IBM Logo.png" style={{width: '15%', minWidth: 200, marginTop: 20}}/>
                <img src="/images/Cigna-logo.png"
                     style={{
                         width: '25%',
                         minWidth: 250,
                         marginBottom: 0,
                         marginTop: 20,
                         marginLeft: 20
                     }}/>
                <img src="/images/BMC%20Logo.png"
                     style={{width: '20%', minWidth: 150, marginTop: floatImg ? 35 : 45}}/>
            </div>
        </div>
    )
}

function Buttons() {
    const nav = useNavigate()
    return (
        <div style={{margin: '30px 0 50px'}}>
            <Button style={{width: '50%'}} onClick={() => nav("/team")}>
                Meet The Founder
            </Button>

            <Button style={{width: '45%', marginLeft: "5%"}} onClick={() => nav("/contact")}>
                Get In Touch
            </Button>
        </div>
    )
}

function WhyUs() {
    return (
        <div style={{textAlign: 'left'}}>
            <h1>
                Why use FSI for your software and project management needs?
            </h1>
            <div>
                <p>
                    At Fullstack Software Innovations, we have extensive experience leading the
                    development of multi-million dollar products for IBM, Cigna Healthcare, BMC Software, and 21CS.
                    We have a proven track record of delivering innovative, scalable, and
                    high-performance Enterprise Software and Software-as-a-Service solutions that support operations
                    for banks, insurance companies, pharmaceutical manufacturers, and retailers all over the world!
                    Our experts have worked on cutting edge inventions for powerful new AI models, cloud
                    computing, and IBM Mainframe technologies. With our deep understanding of Quantum and other advanced
                    computing methods, FSI is the perfect solution for your business to flourish in rapidly
                    changing technology and strategic landscapes.
                </p>

                <p>
                    The expertise that FSI brings to your software operation spans the entire software
                    development lifecycle. From conceptualization and software architecture, development and deployment,
                    through optimization and support we've done it all. We can help your business strategize for success
                    to leverage AI products and tools that will decrease costs, streamline operations, and provide
                    new cutting-edge services and customer experiences. Our software experts can also help your business
                    manage cross-functional teams to drive collaboration across engineering, UI design, and product
                    management to deliver software on time and within budget. Our leadership and technical skills have
                    consistently resulted in the creation of impactful, market-leading products that drive revenue
                    growth and elevate organizational success.
                </p>

                <p>
                    While many businesses use off-the-shelf solutions for their enterprise software, there
                    is no comparison to having experts in the field advise you on the best strategies and products or
                    to have custom-built tailored software from a team of engineers and managers that
                    put your business's and customer's needs first.
                    Fullstack Software Innovations can help your business enhance its operations to keep up with
                    the rapidly-paced changing technology and improve customer satisfaction and retention with software
                    tools that meet your needs. Whether it's business strategy consulting, AI optimizations,
                    or on-site software solutions: FSI has you covered.
                </p>
            </div>
        </div>
    )
}

function FSICube({floatImg}){
    return (
        <div style={{
            float: floatImg ? 'right' : 'none',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column'
        }}>
            <div style={{marginLeft: floatImg ? 40 : 0}}>
                <img src="/images/FSI Cube.png"
                     align="top"
                     alt="its-a-me"
                     style={{
                         width: '35vh', minWidth: 250,
                         display: 'inline-block',
                         marginTop: 10
                     }}
                />
            </div>

        </div>
    )
}